var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/esnext.symbol.observable.js
// module id = 420
// module chunks = 0 1